
    /**
     * Bitwise circular shift right
     * http://en.wikipedia.org/wiki/Circular_shift
     */
    function ror(val, shift){
        return (val >> shift) | (val << (32 - shift));
    }
    module.exports = ror;




//////////////////
// WEBPACK FOOTER
// ./~/mout/number/ror.js
// module id = 1629
// module chunks = 0 1 2